import { parseMapboxPublicToken } from '../config/mapbox';
import { startingPlaceTitle } from '../domain/starting-place';
import type { RidePoint } from '../domain/ride';

/** Sends only the starting coordinate; permanent results may be saved with the draft. */
export async function lookupStartingPlace(point: Pick<RidePoint, 'latitude' | 'longitude'>, signal: AbortSignal) {
  const token = parseMapboxPublicToken(import.meta.env.VITE_MAPBOX_PUBLIC_TOKEN);
  if (!token || !Number.isFinite(point.latitude) || Math.abs(point.latitude) > 90
    || !Number.isFinite(point.longitude) || Math.abs(point.longitude) > 180) throw new Error('Starting location lookup is unavailable.');
  const query = new URLSearchParams({ latitude: String(point.latitude), longitude: String(point.longitude),
    types: 'locality,place,district,region,country', language: 'en', permanent: 'true', access_token: token });
  try {
    const response = await fetch(`https://api.mapbox.com/search/geocode/v6/reverse?${query}`, {
      signal: AbortSignal.any([signal, AbortSignal.timeout(8000)]), credentials: 'omit', cache: 'no-store', referrerPolicy: 'origin',
    });
    if (!response.ok) throw new Error('Lookup failed.');
    const title = startingPlaceTitle(await response.json());
    if (!title) throw new Error('No place returned.');
    return title;
  } catch {
    // Keep provider errors and token-bearing request URLs out of UI and logs.
    throw new Error('Starting location lookup is unavailable.');
  }
}
